module.exports = __webpack_public_path__ + "static/media/edit_Itinerary.9675efd4.svg";